module.exports = __webpack_public_path__ + "static/media/WEO76REQ0001.61f3ee76.svg";